import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'
import { CellLoader } from '~modals/SettingsModal/Preloader'

export function Preloader() {
    return (
        <div className={styles.tab}>
            <Loader width={70} height={18} />
            <CellLoader withAction={false} />

            <div className={styles.terminateSessions}>
                <Loader width={150} height={18} />
            </div>

            <Loader width={95} height={18} />

            <div className={styles.sessions}>
                {Array.from({ length: 5 }).map((_, index) => (
                    <CellLoader isSmallAction key={index} />
                ))}
            </div>
        </div>
    )
}
